import React, { createContext, useContext, useState } from 'react';

const MobileNavContext = createContext({ menuOpen: false, setMenuOpen: () => {} });

export const MobileNavProvider = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <MobileNavContext.Provider value={{ menuOpen, setMenuOpen }}>
      {children}
    </MobileNavContext.Provider>
  );
};

export const useMobileNav = () => useContext(MobileNavContext);

export default MobileNavContext;
